export default [
  {
    path: '/teemail/verified',
    alias: ['/teemail/verified/'],
    name: 'teemail.verified',
    props: true,
    meta: {
      title: 'Subscription Verified',
      layout: 'blank',
    },
    component: () => import('./Verified.vue'),
  },
  {
    path: '/teemail/unsubscribed',
    alias: ['/teemail/unsubscribed/'],
    name: 'teemail.unsubscribed',
    props: true,
    meta: {
      title: 'Unsubscribed',
      layout: 'blank',
    },
    component: () => import('./Unsubscribed.vue'),
  },
  {
    path: '/subscription-verified',
    alias: ['/subscription-verified/'],
    redirect: '/teemail/verified',
  },
  {
    path: '/communication-preferences/update',
    alias: ['/communication-preferences/update/'],
    redirect: '/teemail/unsubscribed',
  },
  {
    path: '/teemail/:page',
    name: 'teemail',
    props: true,
    meta: {
      title: 'Teemail',
      breadcrumb: {
        type: 'page',
        parent: 'home',
      },
      layout: 'mail',
    },
    component: () => import('./TeemailPage.vue'),
  },
];
